import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import family from "../assets/family.webp";
import marriage from "../assets/Marriage.webp";
import retirement from "../assets/Retirement.webp";
import plane from "../assets/plane.webp";

const Home = () => {
  const navigate = useNavigate();

  const handleExpertAdvice = () => {
    navigate("/contact-us");
  };

  const goals = [
    { title: "Vacation Planning", icon: plane },
    { title: "Car Planning", icon: "🚙" },
    { title: "Child's Education", icon: "🎓" },
    { title: "Child's Marriage", icon: marriage },
    { title: "Retirement", icon: retirement },
    { title: "Life Insurance", icon: "🤝" },
  ];

  return (
    <div className="bg-gray-100 min-h-screen">
      <div className="relative w-full h-[380px] lg:h-[548px]">
        <img
          src={family}
          alt="Business Consulting"
          loading="lazy"
          className="w-full h-full object-fill"
        />
        <div className="absolute inset-0 flex items-end pb-8 justify-center bg-black bg-opacity-50">
          <motion.p
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: false }}
            className="text-white text-4xl lg:text-6xl font-semibold text-center px-4 opacity-25"
          >
            "Empowering Individuals and Businesses, Securing Financial Futures"
          </motion.p>
        </div>
      </div>

      <div className="p-8">
        <h2 className="text-4xl font-bold mb-6">WHO WE ARE</h2>
        <p className="text-16px md:text-18px lg:text-20px mb-4 font-poppins leading-relaxed text-justify">
          <strong>HYVIRU Fintech LLP</strong> is a professionally managed
          investment and financial services firm committed to delivering
          intelligent, transparent, and result-oriented financial solutions. We
          help individuals, corporations, trusts, educational institutions, and
          government organizations optimize their investments, preserve capital,
          and achieve sustainable long-term growth.
        </p>
        <p className="text-16px md:text-18px lg:text-20px mb-8 font-poppins leading-relaxed text-justify">
          By combining market expertise, disciplined investment strategies, and
          a client-first philosophy, we provide customized financial solutions
          that align with each client's objectives, risk profile, and investment
          horizon.
        </p>
        <Link
          to="/services"
          className="bg-[#2f2aba] text-white px-6 py-3 rounded hover:bg-primary"
        >
          Explore Our Services
        </Link>
      </div>

      <motion.section
        className="bg-black text-white py-12 px-6 rounded-md"
        initial={{ opacity: 1, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl font-bold leading-snug mb-6">
              GIVE SHAPE TO YOUR{" "}
              <span className="text-green-400">INVESTMENTS....</span>
            </h2>
            <p className="text-lg mb-8 leading-relaxed text-justify">
              Financial goals are the priorities and targets you set for how you
              want to spend and save your money. They aren't one size fits all,
              because everyone has different priorities. However, if you don't
              set your financial goals, you'll probably be left wondering where
              all your money went. Importance of Setting Goals.
            </p>
            <button
              onClick={handleExpertAdvice}
              className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-md font-semibold transition"
            >
              Need Expert Advice
            </button>
          </div>

          {/* Right Content - Goal Cards */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-6">
            {goals.map((goal, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: index * 0.4 }}
                viewport={{ once: true }}
                className="bg-gray-800 p-6 rounded-lg flex flex-col items-center text-center hover:bg-gray-700 transition"
              >
                <div className="text-5xl mb-4">
                  {typeof goal.icon === "string" &&
                  goal.icon.startsWith("data") === false &&
                  !goal.icon.includes("/") ? (
                    goal.icon // emoji
                  ) : (
                    <img
                      src={goal.icon}
                      alt={goal.title}
                      className="w-16 h-16 rounded-md"
                    />
                  )}
                </div>
                <p className="text-lg font-semibold">{goal.title}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default Home;
